import { ComboBox, IconButton, SelectableOptionMenuItemType } from '@fluentui/react';
import React, { Component, Fragment } from 'react';

export class PickerPerimetre extends Component {

    static defaultProps = {
        accesPerimetreEiffage: true,
        onChange: items => null,
        regions: [],
        agences: [],
        programmes: [],
        regionsAdministratives: [],
        departementsAdministratifs: [],
        villesAdministratives: [],
        operations: [],
    };

    static defaultState = {
        showInput: false,
        searchedValue: "",
    };

    constructor(props) {
        super(props);
        this.state = { ...PickerPerimetre.defaultState };
        this.inputRef = React.createRef();
    };

    _getOptions = () => {
        const { accesPerimetreEiffage, regions, agences, programmes, regionsAdministratives, departementsAdministratifs, villesAdministratives, operations } = this.props;
        const { searchedValue } = this.state;

        let applyFilter = !!searchedValue && searchedValue.length >= 3;
        applyFilter = applyFilter || (!!searchedValue && searchedValue.length >= 2 && !isNaN(searchedValue)); // Si saisie est un nombre (id) alors lancer une recherche dès 2 caractères saisis

        if (applyFilter) {

            const filter = searchedValue.toLowerCase();
            let options = [];

            if (accesPerimetreEiffage) {

                // Régions
                const filteredRegions = regions
                    .filter(region =>
                        region.region.toLowerCase().includes(filter)
                        || region.idRegion.toString().includes(filter)
                    )
                    .map(region => ({ key: `region-${region.idRegion}`, text: region.region, data: region }));

                // Agences
                const filteredAgences = agences
                    .filter(agence =>
                        agence.agence.toLowerCase().includes(filter)
                        || agence.idAgence.toString().includes(filter)
                    )
                    .map(agence => ({ key: `agence-${agence.idAgence}`, text: agence.agence, data: agence }));

                // Programmes
                const filteredProgrammes = programmes
                    .filter(programme =>
                        programme.programmeCommercial.toLowerCase().includes(filter)
                        || programme.idProgramme.toString().includes(filter)
                    )
                    .map(programme => ({ key: `programme-${programme.idProgramme}`, text: programme.programmeCommercial, data: programme }));

                if (filteredRegions.length > 0) {
                    options.push({ key: "filteredRegions", text: "Régions", itemType: SelectableOptionMenuItemType.Header },)
                    options = options.concat(filteredRegions);
                }
                if (filteredAgences.length > 0) {
                    options.push({ key: "filteredAgences", text: "Agences", itemType: SelectableOptionMenuItemType.Header },)
                    options = options.concat(filteredAgences);
                }
                if (filteredProgrammes.length > 0) {
                    options.push({ key: "filteredProgrammes", text: "Programmes", itemType: SelectableOptionMenuItemType.Header },)
                    options = options.concat(filteredProgrammes);
                }

            } else {

                // Régions administratives
                const filteredRegionsAdministratives = regionsAdministratives
                    .filter(region =>
                        region.regionAdministrative.toLowerCase().includes(filter)
                        || region.idRegionAdministrative.toString().includes(filter)
                    )
                    .map(region => ({ key: `region-${region.idRegionAdministrative}`, text: region.regionAdministrative, data: region }));

                // Départements administratifs
                const filteredDepartementsAdministratifs = departementsAdministratifs
                    .filter(departement =>
                        departement.departementAdministratif.toLowerCase().includes(filter)
                        || departement.idDepartementAdministratif.toString().includes(filter)
                    )
                    .map(departement => ({ key: `agence-${departement.idDepartementAdministratif}`, text: departement.departementAdministratif, data: departement }));

                // Villes administratives
                const filteredVillesAdministratives = villesAdministratives
                    .filter(ville =>
                        ville.villeAdministrative.toLowerCase().includes(filter)
                        || ville.idVilleAdministrative.toString().includes(filter)
                    )
                    .map(ville => ({ key: `programme-${ville.idVilleAdministrative}`, text: ville.villeAdministrative, data: ville }));

                if (filteredRegionsAdministratives.length > 0) {
                    options.push({ key: "filteredRegionsAdministratives", text: "Régions", itemType: SelectableOptionMenuItemType.Header },)
                    options = options.concat(filteredRegionsAdministratives);
                }
                if (filteredDepartementsAdministratifs.length > 0) {
                    options.push({ key: "filteredDepartementsAdministratifs", text: "Départements", itemType: SelectableOptionMenuItemType.Header },)
                    options = options.concat(filteredDepartementsAdministratifs);
                }
                if (filteredVillesAdministratives.length > 0) {
                    options.push({ key: "filteredVillesAdministratives", text: "Villes", itemType: SelectableOptionMenuItemType.Header },)
                    options = options.concat(filteredVillesAdministratives);
                }

            }

            // Opérations
            const filteredOperations = operations
                .filter(operation =>
                    operation.nomCommercial.toLowerCase().includes(filter)
                    || operation.idOperation.toString().includes(filter)
                )
                .map(operation => ({ key: `operation-${operation.idOperation}`, text: operation.nomCommercial, data: operation }));

            if (filteredOperations.length > 0) {
                options.push({ key: "filteredOperations", text: "Opérations", itemType: SelectableOptionMenuItemType.Header },)
                options = options.concat(filteredOperations);
            }

            return options;

        }
        else return [];
    };

    _onRenderOption = (props, defaultRender) => {
        const option = defaultRender(props);
        if (!!props && !!props.data) {
            const { data } = props;
            const { idRegion, idAgence, idProgramme, idRegionAdministrative, idDepartementAdministratif, idVilleAdministrative, idOperation } = data;
            return <Fragment>
                <span style={{ fontSize: ".8rem" }} className="badge badge-secondary mr-1">{idOperation || idProgramme || idAgence || idRegion || parseInt(idVilleAdministrative) || parseInt(idDepartementAdministratif) || idRegionAdministrative}</span>
                {option}
            </Fragment>;
        }
        else return option;
    };

    componentDidUpdate = (prevProps, prevState) => {
        if (!prevState.showInput && this.state.showInput) {
            const shouldOpenOnFocus = true;
            this.inputRef.focus(shouldOpenOnFocus);
        }
    };

    render = () => {
        const { onChange, operations } = this.props;
        const { searchedValue, showInput } = this.state;

        if (showInput) return <ComboBox
            allowFreeform
            autofill={{
                onInputValueChange: (newValue, composing) => this.setState({ searchedValue: newValue }),
                value: searchedValue
            }}
            caretDownButtonStyles={{ root: { display: "none" } }} // Masque le caret down
            componentRef={input => this.inputRef = input} // Référence utilisée pour positionner le focus sur l'input
            onBlur={event => this.setState({ ...PickerPerimetre.defaultState })} // Remise à zéro
            onChange={(event, option, index, value) => { // A la sélection appel de la prop et remise à zéro
                const callback = !!option ? () => onChange(event, option, index, value) : undefined;
                this.setState({ ...PickerPerimetre.defaultState }, callback);
            }}
            onRenderOption={this._onRenderOption}
            options={this._getOptions()}
            placeholder="Rechercher"
            selectedKey={undefined}
            styles={{ root: { paddingRight: "9px" } }} // Adapte l'input au fait que le caret down soit masqué
        />
        else return <IconButton
            disabled={operations.length === 0}
            iconProps={{ iconName: "MapPin" }}
            onClick={event => this.setState({ showInput: true })}
        />;
    };

};